<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="survey.id">{{$t('modals.edit_survey.title')}}</h1>
            <h1 v-else>{{$t('modals.start_survey.title')}}</h1>
        </div>

        <survey-form
            :survey="survey"
            :wrapperClass="['modal__content']"
            @saved="onSave">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </survey-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import SurveyForm from '@/components/forms/dashboard/SurveyForm';

    import { GET_SURVEYS } from '@/store/modules/surveys';

    @Component({
        components: {
            SurveyForm,
        }
    })
    export default class SurveyModal extends Vue {
        name = 'survey-modal';
        survey = {};
        isNew = false;

        beforeOpen(event) {
            if (event.params && event.params.survey) {
                this.survey = event.params.survey;
                this.isNew = !this.survey.id;
            }
        }

        onSave(survey) {
            // If the survey was just created, then also start it
            if (this.isNew) {
                this.startSurvey(survey);
            } else {
                this.refetchAndClose();
            }
        }

        startSurvey(survey) {
            return this.axios.post(`trajectories/${this.trajectoryId()}/surveys/${survey.id}/start`, {})
                .then(res => {
                    this.$notify.success(this.$t('notify.survey.start_success'));
                    this.refetchAndClose();
                }).catch(err => {
                    this.$notify.error(this.$t('notify.survey.start_error'));

                    // Delete the survey if it fails to be started
                    this.axios.delete(`trajectories/${this.trajectoryId()}/surveys/${survey.id}`).then(this.refetchAndClose);
                });
        }

        refetchAndClose() {
            this.$store.dispatch(GET_SURVEYS, {});
            this.$modal.hide(this.name);
        }


        trajectoryId() {
            return this.$store.state.trajectory.trajectory.id;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/SurveyModal.vue